import React from 'react';
import { waLink, WaIcon } from '../App';

const TYPES = {
  cake:    { label:'1Kg Cakes',  sub:'Celebration cakes, hand-piped & personalised. Choose your flavour, request your message.' },
  cupcake: { label:'Cupcakes',   sub:'Boxes of 6, pick a flavour and a topping style: flowers, bows or characters.' },
  bento:   { label:'Bento Sets', sub:'A 500g cake plus 5 matching cupcakes, the perfect little gift in one box.' },
};

const TIERS = { classic:'Classic', premium:'Premium', special:'Special Edition' };

const FLAVORS = {
  classic: ['Vanilla','Banana','Lemon','Carrot','Chocolate','Strawberry'],
  premium: ['Pina Colada','Red Velvet','Lotus Biscoff','Coffee Mocha','Chocolate Mint','Cookie & Cream'],
  special: ['Berry Vanilla','Pink Lemonade','Lemon Blueberry','Orange Chocolate','Tropical Berry'],
};

const PRICE = {
  cake:{
    classic:{Vanilla:3100,Banana:3400,Lemon:3600,Carrot:3800,Chocolate:4000,Strawberry:4500},
    premium:{'Pina Colada':3500,'Red Velvet':3900,'Lotus Biscoff':4700,'Coffee Mocha':3500,'Chocolate Mint':4100,'Cookie & Cream':3700},
    special:{'Berry Vanilla':3700,'Pink Lemonade':5100,'Lemon Blueberry':5700,'Orange Chocolate':4900,'Tropical Berry':4500},
  },
  cupcake:{
    classic:{Vanilla:1000,Banana:1100,Lemon:1100,Carrot:1200,Chocolate:1200,Strawberry:1400},
    premium:{'Pina Colada':1100,'Red Velvet':1200,'Lotus Biscoff':1400,'Coffee Mocha':1100,'Chocolate Mint':1300,'Cookie & Cream':1200},
    special:{'Berry Vanilla':1100,'Pink Lemonade':1500,'Lemon Blueberry':1600,'Orange Chocolate':1400,'Tropical Berry':1300},
  },
  bento:{
    classic:{Vanilla:2600,Banana:2800,Lemon:2900,Carrot:3000,Chocolate:3200,Strawberry:3600},
    premium:{'Pina Colada':2900,'Red Velvet':3100,'Lotus Biscoff':3800,'Coffee Mocha':2900,'Chocolate Mint':3300,'Cookie & Cream':3000},
    special:{'Berry Vanilla':3000,'Pink Lemonade':4100,'Lemon Blueberry':4500,'Orange Chocolate':3900,'Tropical Berry':3600},
  },
};

function ksh(n) { return 'Ksh ' + n.toLocaleString('en-US'); }

export default function Menu({ menuType, setMenuType }) {
  return (
    <section id="menu" style={{ padding:'20px 0 90px' }}>
      <div style={{ maxWidth:1180, margin:'0 auto', padding:'0 26px' }}>
        <div style={{ textAlign:'center', maxWidth:620, margin:'0 auto 44px' }}>
          <span style={{ fontFamily:'var(--sans)', fontWeight:700, fontSize:12, letterSpacing:2.6, textTransform:'uppercase', color:'var(--plum)', display:'inline-flex', alignItems:'center', justifyContent:'center', gap:9 }}>
            Flavours &amp; prices
          </span>
          <h2 style={{ fontSize:'clamp(2.3rem,4.4vw,3.4rem)', margin:'12px 0 12px' }}>The menu</h2>
          <p style={{ color:'var(--ink-2)', fontSize:18, margin:0 }}>Pick a line, pick a tier, pick a flavour. Custom toppers &amp; messages are quoted on request.</p>
        </div>

        <div style={{ background:'var(--blush)', border:'1px solid var(--line)', borderRadius:24, padding:'38px clamp(20px,4vw,52px)', boxShadow:'var(--shadow-sm)' }}>
          <div style={{ display:'flex', justifyContent:'center', gap:10, flexWrap:'wrap', marginBottom:10 }}>
            {Object.entries(TYPES).map(([key, v]) => (
              <button key={key} onClick={() => setMenuType(key)}
                style={{ fontFamily:'var(--sans)', fontWeight:700, fontSize:14.5, padding:'11px 22px', borderRadius:30, border:'1.5px solid var(--plum)', background: menuType === key ? 'var(--plum)' : 'transparent', color: menuType === key ? '#fff' : 'var(--plum-deep)', cursor:'pointer', transition:'all .2s' }}>
                {v.label}
              </button>
            ))}
          </div>

          <p style={{ textAlign:'center', color:'var(--ink-3)', fontSize:13.5, margin:'0 0 26px' }}>{TYPES[menuType].sub}</p>

          {Object.entries(TIERS).map(([tk, tv]) => (
            <div key={tk} style={{ marginTop:30 }}>
              <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:14 }}>
                <span style={{ fontFamily:'var(--serif)', fontSize:27, color:'var(--plum-deep)', whiteSpace:'nowrap' }}>{tv}</span>
                <span style={{ fontSize:10.5, fontWeight:700, letterSpacing:1.4, textTransform:'uppercase', color:'var(--gold)', border:'1.4px solid var(--gold)', borderRadius:20, padding:'3px 10px' }}>{TYPES[menuType].label}</span>
                <span style={{ flex:1, height:1, background:'var(--line)' }} />
              </div>
              <div style={{ columns:2, columnGap:46 }} className="kt-flav">
                {FLAVORS[tk].map(f => (
                  <div key={f} style={{ display:'flex', alignItems:'baseline', gap:10, padding:'6px 0', breakInside:'avoid' }}>
                    <span style={{ fontSize:16, color:'var(--ink)' }}>{f}</span>
                    <span style={{ flex:1, borderBottom:'1.5px dotted var(--ink-3)', opacity:.5, transform:'translateY(-4px)' }} />
                    <span style={{ fontFamily:'var(--serif)', fontWeight:700, fontSize:19, color:'var(--plum-deep)' }}>{ksh(PRICE[menuType][tk][f])}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <div style={{ textAlign:'center', marginTop:34 }}>
            <p style={{ color:'var(--ink-2)', fontSize:14.5, marginBottom:16 }}>All cakes made to order with 2 to 3 days notice · prices in Kenyan Shillings.</p>
            <a href={waLink("Hi Kreme Tops! I'd like to order from the menu.")} target="_blank" rel="noopener noreferrer"
              style={{ display:'inline-flex', alignItems:'center', gap:9, fontFamily:'var(--sans)', fontWeight:700, fontSize:14.5, padding:'14px 24px', borderRadius:40, background:'var(--plum)', color:'#fff', boxShadow:'var(--shadow-sm)', textDecoration:'none', transition:'background .2s' }}
              onMouseOver={e => e.currentTarget.style.background='var(--plum-deep)'}
              onMouseOut={e => e.currentTarget.style.background='var(--plum)'}>
              <WaIcon />Order on WhatsApp
            </a>
          </div>
        </div>
      </div>
      <style>{`@media(max-width:600px){.kt-flav{columns:1!important;}}`}</style>
    </section>
  );
}
